export default __webpack_public_path__ + "static/media/windowReplacement.ac742814.jpg";